import React from 'react';
import '../App.css'
import { Link } from 'react-router-dom';
import { AiOutlineClose } from 'react-icons/ai';
import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
import { Combobox } from '@headlessui/react'
import { userService } from '../services/UserService';
import { deleteLocalStorage, authHeader, gettokens, getDidTokens } from "../helpers/auth-header";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { homeDataConstants } from '../constants/HomeDataConstants';

import Autocomplete from 'react-google-autocomplete';

import {
	Bars3Icon,
	XMarkIcon
} from '@heroicons/react/24/outline'


import Axios from "axios";
import { Fragment, useState } from 'react'
import SideMenu from './SideMenu';
import FailureModal from './FailureModal';
import SuccessModal from './SuccessModal';

var url = process.env.REACT_APP_URL || "http://localhost:8080/";

const firebaseConfig = {
	apiKey: "AIzaSyCT-HKuQUQT94cSIF5Fu7zzPnWbn9ao8i0",
	authDomain: "hopguides.firebaseapp.com",
	projectId: "hopguides",
	storageBucket: "hopguides.appspot.com",
	messagingSenderId: "520191148823",
	appId: "1:520191148823:web:f1920e502d3f692840ad52"
};

firebase.initializeApp(firebaseConfig);

function LoadingOverlay() {
	return (
		<div className="loading-container">
			<div className="loading-spinner "></div>
			<div className="loading-text !text-gray-400 !text-sm ">Generating experience... This may take up to 5 minutes. </div>
		</div>
	);
}


function LoadingOverlay1() {
	return (
		<div className="loading-overlay flex flex-col items-center justify-center">
			<div className="loading-spinner"></div>
			<div className="loading-text">This may take up to five minutes</div>
		</div>
	);
}

function VideoModal({ points, isOpen, setIsOpen }) {

	const { homeDataState, dispatch } = React.useContext(HomeDataContext);

	return (
		<div className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">

			{/* Modal Overlay */}
			<div className="modal-overlay"></div>

			{/* Modal */}
			<div className="modal-frame">

				{/* Modal Content */}
				<div id="myModal" className="modal !w-3/5 bg-white rounded-lg shadow-xl">

					<div className="modal__header bg-gray-800 p-4 rounded-t-lg">
						<h2 className="text-xl leading-6 font-bold text-white">
							Your experience
						</h2>
						<button className="button button--circle button--clear justify-self-end " type="button" onClick={() => {
							dispatch({
								type: 'SEND_DEMO_LOADING_CLOSE',
							}
							);
							setIsOpen(false)
						}
						}>
							<AiOutlineClose className='text-white' />
						</button>
					</div>
					{/* Close button */}


					<div className="mt-3">

						<div className="modal__body p-6">
							<h1 className="text-lg font-semibold mb-2">Payment link:</h1>
							<div className="mb-4 p-3 bg-gray-50 border border-gray-200 rounded">
								https://hopguides-video-creation.netlify.app/#/tourpayment/{homeDataState.tourVideo.id}
							</div>

							<h1 className="text-lg font-semibold mt-6">Ads</h1>
							<div className="flex flex-col items-center justify-center p-5">
								<textarea rows="4" name="comment" value={homeDataState.adds} id="comment" className="form__input resize-none h-96 w-full p-2 border border-gray-300 rounded-md" />
							</div>
						</div>




						{/* Points list */}
						{points.map((point, index) => (
							<div key={point.id} className={`mb-4 flex flex-col items-center ${index < points.length - 1 ? 'border-b' : ''} border-gray-300`}>

								{/* Chapter Heading */}
								<h2 className="text-lg font-semibold">Chapter {index + 1}</h2>

								<div className="w-1/2 max-w-xs">
									{point.video != null && (
										<video controls className="w-full">
											<source src={point.video} type="video/mp4" />
											Your browser does not support the video tag.
										</video>
									)}
								</div>
								<div className="mt-2 text-sm text-gray-500 w-full text-center">{point.text}</div>
								{/* Separator */}
								{index < points.length - 1 && <hr className="my-4 w-full border-gray-300" />}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}

function TextBoxes1({ selectedImage, description, setDescription, tokens, setCountTokens, countTokens, selectedVoice }) {


	const { homeDataState, dispatch } = React.useContext(HomeDataContext);
	const [selectedProductId, setSelectedProductId] = React.useState(1);
	const [selectedIndex, setSelectedIndex] = React.useState("");


	const renderDescription = () => {


		return description

	};

	const handleClose = () => {

		setCountTokens(false)
	};

	const goBack = (e) => {

		dispatch({
			type: homeDataConstants.GO_BACK
		});
	};

	const handleSend = async () => {
		setCountTokens(false);
		var ofTokens = parseFloat(gettokens()) - parseFloat(tokens);
		dispatch({
			type: 'SEND_DEMO_REQUEST',

		});
		// Iteracija skozi vsak element zgodbe
		for (let i = 0; i < homeDataState.story.length; i++) {
			let storyItem = homeDataState.story[i];

			console.log(storyItem)
			// Priprava podatkov za vsak element zgodbe
			var data = {
				character: selectedImage,
				words: JSON.stringify(storyItem), // Uporaba besedila elementa zgodbe
				tokens: gettokens(),
				tokensneeded: tokens,
				voice: selectedVoice,
				chapter: i, // Uporaba indeksa kot številke poglavja
				tour: homeDataState.tourVideo
			};

			console.log(data)
			// Klicanje storitve za vsak element zgodbe
			await homeDataService.getDemoVideo(dispatch, data, ofTokens);
		}

		var data = {
			story: homeDataState.story,
			tour: homeDataState.tourVideo
		}

		const generatedText = await homeDataService.generateaddposts(dispatch, data);
		dispatch({
			type: 'SEND_DEMO_LOADING_DONE',

		});
	};

	const handleDescriptionChange = (newDescription) => {
		setDescription(newDescription); // Update the local state for the description

		// Dispatch an action to update the story in the context
		dispatch({
			type: 'UPDATE_STORY_CHAPTER',
			payload: {
				index: selectedIndex,
				newDescription: newDescription
			}
		});
	};
	return (
		<div className="grow flex flex-col items-stretch md:h-screen md:overflow-hidden">

			{countTokens &&

				// Modal
				<div className="fixed z-50 inset-0" aria-labelledby="modal-title" role="dialog" aria-modal="true">

					{/* Modal Overlay */}
					<div className="modal-overlay"></div>

					{/* Modal */}
					<div className="modal-frame">

						{/* Modal Content */}
						<div id="myModal" className="modal modal--md">

							<div className="modal__header">
								<h2 className="text-leading scaled-title-menu text-black font-bold">
									Ready to generate your experience?
								</h2>
								<button className="button button--circle button--clear justify-self-end" type="button" onClick={handleClose}>
									<AiOutlineClose />
								</button>
							</div>

							<div className="modal__body flex flex-col justify-center p-5">

								<div className="flex flex-col gap-4 items-center justify-center">
									{/* Character Video */}
									<div className="w-full max-w-xs aspect-[3/4] rounded-xl overflow-hidden mx-auto md:mx-0 md:float-left md:mr-4 mb-4 md:mb-2 border border-white/20 relative z-10 self-center">

										<div className="absolute left-2 top-2 z-10 text-[0.65rem] tracking-wider uppercase bg-black/60 backdrop-blur px-1.5 py-1 rounded-lg text-white">
											Preview
										</div>

										{selectedImage.length < 15 && <img className="h-full w-full object-cover" src={`https://hopguides.s3.eu-central-1.amazonaws.com/video-images/character_descriptions/${selectedImage.slice(3,).toLowerCase()}.png`}></img>}
										{selectedImage.length > 15 && <img src={selectedImage} className=" border border-gray-300 bg-white text-gray-300"></img>}

									</div>

									{/* Cost */}
									<div className="flex flex-col gap-1 text-center">
										<div className="font-semibold text-black">
											{tokens} credits
										</div>
										<div className="text-xs text-black opacity-60">
											Available: {gettokens()} credits
										</div>
									</div>

									{(parseFloat(gettokens()) - parseFloat(tokens) < 0) &&
										<p className="text-center text-red-500 text-m font-bold mb-4">
											You don't have enough credits to generate video
										</p>
									}

									<div className="flex space-x-2 items-center justify-center py-3">
										<button onClick={e => handleClose(e)} className="button button-dimensions button--secondary min-w-[10rem]">
											Cancel
										</button>
										{(parseFloat(gettokens()) - parseFloat(tokens) > 0) &&
											<button onClick={e => handleSend(e)} className="button button-dimensions button--primary min-w-[10rem]">
												Generate now
											</button>
										}
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>}

			{/* Choose Use Case */}
			<div className="grow h-[50vh] md:h-full bg-neutral-100 pt-16 lg:pt-0 overflow-y-scroll">

				<div htmlFor="useCases" className="sticky z-10  top-0 p-5 bg-neutral-100 bg-opacity-90 backdrop-blur">
					<div className="section-title">
						 <div className="label-count">5</div> This is the story we created, check generated stories:
					</div>
				</div>

				<div className="grid-menu grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 p-5 pt-1 pb-20">
					{homeDataState.story.map((product, index) => (

						<div
							key={product}
							className={`grid-menu-item item-hover ${selectedProductId === product ? 'grid-menu-item--active' : 'grid-menu-item'}`}
							onClick={(e) => {
								setDescription(product);
								setSelectedProductId(product);
								setSelectedIndex(index); // Set the selected product ID
							}}

						>
							<div className="p-4">
								<h3>
									POI {index + 1}
								</h3>
								<small>
									{product}
								</small>
							</div>
						</div>
					))}
				</div>

				{homeDataState.loadingStory1 && (
					<LoadingOverlay />
				)}
			</div>

			{/* Customize Your Content */}
			<div className="flex flex-col gap-5 p-5 shadow-inverted relative z-20">

				<div htmlFor="useCases">
					<div className="section-title">
						<div className="label-count">6</div> Edit content
					</div>
				</div>


				{/* Content Text */}
				<textarea
					className="form__input resize-none text-sm min-h-[300px] h-72 md:min-h-0"
					cols={30}
					rows={6}
					name="comment"
					value={renderDescription()}
					onChange={e => handleDescriptionChange(e.target.value)}
					id="comment"
				></textarea>

			</div>
		</div>
	);
}

function PhotoGallery({ selectedImage, setSelectedImage, videoMapping, handleImageUpload, uploadedFile, selectedVoice, setSelectedVoice, setUploadedFile, setErrorMessage }) {

	return (
		<div className="bg-white ">
			<div className="">
				<div className="grid-menu grid-cols-5 md:grid-cols-4 lg:grid-cols-5 2xl:grid-cols-7 gap-2">
					{['Sam', 'Isabella', 'Lorenzo', 'Maria', 'Johann', 'Nia', 'Esperanza', 'Diego', 'Sophie', 'Samuel'].map((name) => (
						<div className={`grid-menu-item w-full aspect-[3/4] overflow-hidden item-hover ${selectedImage === `img${name}` ? 'grid-menu-item--active' : ''}`}>
							<img
								id={`img${name}`}
								src={`https://hopguides.s3.eu-central-1.amazonaws.com/video-images/character_descriptions/${name.toLowerCase()}.png`}
								alt={`${name}`}
								className={`object-cover w-full h-full`}
								onClick={() => {
									setErrorMessage("")
									setSelectedImage(`img${name}`);
								}}
							/>
						</div>
					))}

					{/* Yours uploaded */}
					{uploadedFile &&
						<div className="grid-menu-item w-full aspect-[3/4] overflow-hidden item-hover">
							<img
								id="image"
								src={uploadedFile}
								alt="Uploaded content"  // Always provide an alt tag for accessibility
								className={`object-cover w-full h-full`}
								onClick={() => {
									setSelectedImage(uploadedFile);
								}}
							/>
						</div>
					}

					{/* Upload Character */}
					<div className="grid-menu-item w-full aspect-[3/4] overflow-hidden item-hover">
						<button className="button button--primary !rounded-none !w-full !h-full !whitespace-normal flex flex-col items-center justify-center relative">
							<input type="file" accept="image/*" onChange={e => handleImageUpload(e)} className="opacity-0 absolute inset-0 z-10 cursor-pointer" />
							<div className="text-xs">
								Uplaod yours
							</div>
						</button>
					</div>

				</div>

				{/* Choose Voice */}
				<div className="flex items-center gap-4 mt-4">
					{uploadedFile &&
						<select className="form__input" onChange={(e) => {
							setErrorMessage("")
							setSelectedVoice(e.target.value)
						}}>
							<option>Select uploaded character's voice</option>
							{['Sam', 'Isabella', 'Lorenzo', 'Maria', 'Johann', 'Nia', 'Esperanza', 'Diego', 'Sophie', 'Samuel'].map((name) => (
								<option value={name}>{name}</option>
							))}
						</select>
					}
				</div>

			</div>
		</div>
	);
}

function StoryVideoGeneration(story, ready) {
	// Moved state to this parent component
	const [selectedVoice, setSelectedVoice] = React.useState("");

	const [admin, setAdmin] = React.useState(false);
	const [errorMessage, setErrorMessage] = React.useState("");
	const [countTokens, setCountTokens] = React.useState(false);
	const [tokens, setTokens] = React.useState("");
	const [description, setDescription] = React.useState(story[0]);
	const [selectedImage, setSelectedImage] = React.useState("imgSam");
	const [updateapi, setUpdateapi] = React.useState(false);
	const [api, setApi] = React.useState("");
	const [sidebarOpen, setSidebarOpen] = useState(false)
	const [isLoaded, setIsLoaded] = React.useState(false); // New state to track loading
	const [isModalOpen, setIsModalOpen] = useState(true);

	const [uploadedFile, setUploadedFile] = React.useState(null);

	const handleCloseModal = () => {
		setIsModalOpen(false); // This will cause the modal to not be rendered
	};
	const { homeDataState, dispatch } = React.useContext(HomeDataContext);
	const videoMapping = {
		'imgSam': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Samm.mp4',
		'imgIsabella': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Isabella_It.mp4',
		'imgLorenzo': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Lorenzo_It.mp4',
		'imgMaria': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Maria_Ger.mp4',
		'imgJohann': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Johann_Ger.mp4',
		'imgNia': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Nia_UK.mp4',
		'imgEsperanza': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Esperanza_Spa.mp4',
		'imgDiego': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Diego_Spa.mp4',
		'imgSophie': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Sophie_Fra.mp4',
		'imgSamuel': 'https://hopguides.s3.eu-central-1.amazonaws.com/video-images/Samuel_Fra.mp4',
		// ... add other mappings here
	};

	const characterDescriptions = {
		'imgIsabella': "Italian Hotel Receptionist. Isabella is a charismatic woman in her early 30s who works at a boutique hotel in Rome. She's multilingual, fluent in Italian, English, Spanish, and French. Known for her stylish attire and warm personality, she always greets guests with her dazzling smile and helpful recommendations for local attractions.",
		'imgLorenzo': "A historian from Rome, Italy, hosts guests in his renovated apartment in a historic building, offering insightful guided tours and sharing lesser-known stories about the Eternal City's fascinating past.",
		'imgMaria': "German Resort Receptionist. Maria, a charming woman in her late 30s, works at a beach resort in Rio de Janeiro. Her energy is infectious, and her helpful recommendations about the city's best samba clubs and hidden culinary gems are always on point. Maria speaks Portuguese and German.",
		'imgJohann': " German Hostel Receptionist. Johann is a friendly, laid-back man in his mid-20s. He works at a popular youth hostel in Berlin and is known for his quick wit and extensive knowledge about the city's underground music scene. He loves connecting with guests from around the world and often organizes group outings to local concerts.",
		'imgNia': "Welsh Bed & Breakfast Receptionist. Nia, a young woman with a cheery demeanor, works at a cozy B&B in the heart of Cardiff. Known for her infectious laughter and knack for storytelling, she can engage guests in English and Welsh, making their stay extra memorable.",
		'imgSam': "An outdoor enthusiast from Colorado, USA, offers his rustic mountain cabin, enhancing the stay with guided hiking recommendations and showcasing his love for the Rockies' beauty.",
		'imgEsperanza': "Spanish Hotel Receptionist. Esperanza is a vibrant woman in her late 20s, working at a beach resort in Ibiza. Known for her sunny disposition and excellent customer service, she always has the best recommendations for beaches, clubs, and restaurants on the island. Esperanza is fluent in Spanish and English, and can also converse in French and Italian.",
		'imgDiego': "Mexican Hostel Receptionist. Diego, a lively man in his mid-20s, runs the front desk at a popular hostel in Cancun. With his insider tips on local eateries and hidden beaches, he is loved by backpackers. He's fluent in Spanish and English.",
		'imgSophie': "French Bed & Breakfast Receptionist. Sophie, a charming woman in her early 50s, works at a quaint B&B in Provence. Her warm, maternal demeanor and her delicious homemade croissants make every guest feel like they're home. She speaks French and English fluently and has a basic understanding of German and Italian.",
		'imgSamuel': " French Hotel Receptionist. Samuel, a friendly man in his early 40s, works at a hotel in Accra. Known for his excellent customer service and captivating stories about local folklore, Samuel converses with guests in English and French."
	};


	React.useEffect(() => {


		// Using an async function inside useEffect
		const fetchData = async () => {
			await userService.getPaid(dispatch);
			var tokens = await userService.getTokens(dispatch);
			var token = authHeader();

			if (token == "null" || tokens == "undefined" || tokens == "null") {
				window.location = "#/login";
			} else {
				setIsLoaded(true); // Set isLoaded to true only if tokens are valid



			};


			Axios.get(`${url}api/users/getRole`, { headers: { Authorization: token } }, { validateStatus: () => true },
			)
				.then((res) => {
					if (res.status === 200) {

						if ("ADMIN" == res.data) {
							setAdmin(true)
						}
						else {
							setAdmin(false)
						}
					}
				})
				.catch((err) => {
				})



		};





		fetchData(); // Call the async function

	}, []); // Empty depe


	const handleClose = () => {

		setUpdateapi(false)
	};


	const handleSend = async () => {



		await homeDataService.updateApi(dispatch, api);

	};
	const handleLogout = () => {
		deleteLocalStorage();
		firebase.auth().signOut().then(function () {
			// Sign-out successful.
		}).catch(function (error) {
			// An error happened.
		});
		window.location = "#/login";
	};


	const handleCountTokens = async () => {
		if (selectedImage.length > 15 && (!selectedVoice || selectedVoice === "Select uploaded character's voice")) {
			setErrorMessage("Please choose voice for your character");
			return;
		} else if (!selectedImage || homeDataState.story.length === 0) {
			setErrorMessage("All fields must be filled out!");
			return;
		} else {
			setCountTokens(true);

			// Calculate the total length of all items in the story
			const totalLength = homeDataState.story.reduce((total, item) => total + item.length, 0);
			var tokens = totalLength / 100;

			setTokens(Math.ceil(tokens)); // Assuming roundUp function is similar to Math.ceil
		}
	};


	const handleOpenVideo = async () => {

		setIsOpenVideo(true)

	}
	const [isOpenVideo, setIsOpenVideo] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const handleImageUpload = (e) => {

		var new_file = new File([e.target.files[0]], 'img' + [e.target.files[0].name]);


		console.log(new_file)
		const formData = new FormData();
		formData.append('file', new_file);

		formData.append('str', "Some string");
		console.log(formData)
		var xhr = new XMLHttpRequest();
		xhr.upload.addEventListener("progress", ProgressHandler, false);
		//xhr.addEventListener("load", SuccessHandler, false);
		//xhr.addEventListener("error", ErrorHandler, false);
		//xhr.addEventListener("abort", AbortHandler, false);
		xhr.open('POST', `${url}api/amadeus/upload`, true);
		xhr.onload = function () {

			if (xhr.status == 200) {
				console.log(xhr.response)
				setUploadedFile(xhr.response)
				setSelectedImage(xhr.response)
				//SuccessHandler()
			} else {
				//ErrorHandler()
			}
		};
		xhr.send(formData);

	};




	const ProgressHandler = (e) => {


	};

	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};

	return (

		<div>

			{/* New */}
			<div className="min-h-screen flex felx-row items-start md:items-stretch md:overflow-hidden divide-x-0 md:divide-x relative">


				{(homeDataState.modalVideo || isOpenVideo) && <VideoModal points={homeDataState.tourVideo.points} isOpen={isOpenVideo} setIsOpen={setIsOpenVideo} />}
				{/* Modal Change API */}



				{updateapi &&

					<div className="fixed z-50 inset-0" aria-labelledby="modal-title" role="dialog" aria-modal="true">

						{/* Modal Overlay */}
						<div className="modal-overlay"></div>

						{/* Modal */}
						<div className="modal-frame">

							{/* Modal Content */}
							<div id="myModal" className="modal modal--lg">

								<div className="modal__header">
									<h2 className="text-leading scaled-title-menu text-black font-bold">
										Change api
									</h2>
									<button className="button button--circle button--clear justify-self-end" type="button" onClick={handleClose}>
										<AiOutlineClose />
									</button>
								</div>

								<div className="modal__body flex flex-col items-center justify-center p-5">
									<textarea rows="4" name="comment" onChange={e => setApi(e.target.value)} value={api} id="comment" className="form__input resize-none" />
								</div>

								<div className="modal__body flex flex-col items-center justify-center p-5 !pt-0">

									<div className="flex space-x-2">
										<button onClick={e => handleClose(e)} className="button button-dimensions button--secondary min-w-[8rem]">
											Cancel
										</button>
										<div><button onClick={e => handleSend(e)} className="button button-dimensions button--primary min-w-[8rem]">
											OK
										</button></div>
									</div>
								</div>

							</div>
						</div>
					</div>

				}

				{homeDataState.loading && <LoadingOverlay1 />}

				{/* Left */}
				<div className="hidden lg:flex ml-72">
				</div>

				<div className="min-h-screen flex flex-col gap-0 items-stretch w-full overflow-hidden lg:divide-y-0">

					{/* Mobile Nav */}
					<div className="flex flex-row items-center justify-between px-5 h-16 lg:hidden fixed z-40 left-0 top-0 right-0 bg-white border-b border-black/10">
						<div>
							<img className="h-8 w-auto" src="assets/img/logo.svg" alt="Your Company" />
						</div>
						<div>
							<button onClick={toggleMenu} className='w-6'>  <Bars3Icon /> </button>
						</div>
					</div>
					{isOpen && (

						<div className="fixed inset-0 z-50 bg-neutral-100/70 backdrop-blur lg:hidden">
							<div className="fixed top-3 right-3 z-50 bg-white rounded-2xl shadow">
								<div className="px-5 pt-5 pb-0 flex flex-row items-center justify-end">
									<button onClick={toggleMenu} className='w-6'><XMarkIcon /></button>
								</div>
								<div>
									<SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} admin={admin} setUpdateapi={setUpdateapi} handleLogout={handleLogout} handleCountTokens={handleCountTokens} />
								</div>
							</div>
						</div>
					)}
					{/* Right */}
					<div className="grow flex ml-8 flex-col md:flex-row items-stretch w-full md:overflow-hidden divide-x-0 md:divide-x divide-y md:divide-y-0">

						{/* Here */}
						{/* Center */}
						<TextBoxes1 selectedImage={selectedImage} description={description} setDescription={setDescription} tokens={tokens} setCountTokens={setCountTokens} countTokens={countTokens} selectedVoice={selectedVoice} />

						{/* Right */}
						<div className="flex flex-col items-stretch md:w-2/5 shrink-0 md:pt-16 lg:pt-0 md:h-screen overflow-y-scroll divide-y">

							{/* Caracter */}
							<div className="grow flex flex-col items-stretch">
								{/* Choose Character */}
								<div className="p-5 shrink-0">
									<div className="section-title">
										<div className="label-count">7</div> Choose character to narrate the chapter
									</div>
								</div>

								<div className="p-5 pt-1">

									<PhotoGallery selectedImage={selectedImage} setSelectedImage={setSelectedImage} videoMapping={videoMapping} handleImageUpload={handleImageUpload} uploadedFile={uploadedFile} selectedVoice={selectedVoice} setSelectedVoice={setSelectedVoice} setUploadedFile={setUploadedFile} setErrorMessage={setErrorMessage} />

								</div>

							</div>

							{errorMessage && (
								<div className="flex flex-col items-center text-sm text-red-500 m">
									{errorMessage}
								</div>
							)}

							{/* Generate Video */}
							<div className="flex flex-col items-stretch gap-4 p-5 shrink-0">
								<div className="flex flex-col gap-4 grow p-5 rounded-2xl dark">
									{/* Preview */}
									<div className="flex flex-col gap-5 grow">

										<div className="section-title">
											<div className="label-count">8</div> Generate your experience
										</div>

										{/* Character */}
										<div className="flex flex-col gap-2 md:block">

											{/* Character Video */}
											<div className="w-full md:w-2/5 max-w-xs md:max-w-lg aspect-[3/4] rounded-xl overflow-hidden mx-auto md:mx-0 md:float-left md:mr-4 mb-4 md:mb-2 border border-white/20 relative z-10">

												<div className="absolute left-2 top-2 z-10 text-[0.65rem] tracking-wider uppercase bg-black/60 backdrop-blur px-1.5 py-1 rounded-lg">
													Preview
												</div>

												{selectedImage.length < 15 && <video controls key={videoMapping[selectedImage]} className="w-full h-full object-cover">
													<source src={videoMapping[selectedImage]} type="video/mp4" />
													Your browser does not support the video tag.
												</video>}
												{selectedImage.length > 15 && <img src={selectedImage} className=" border border-gray-300 bg-white text-gray-300"></img>}

											</div>

											<div>
												{/* Character Name */}
												<h3 className="font-bold text-xl">
													{selectedImage.slice(3,)}
												</h3>

												{/* Character Description */}
												<p className="mt-1 text-xs opacity-80">
													{characterDescriptions[selectedImage]}
												</p>
											</div>

											{/* Clear Floats */}
											<div className="clear-both"></div>

										</div>
									</div>

									{/* Generate Video Btn */}
									<div className="pt-5 pb-1 shrink-0 flex justify-between items-end border-t border-white/20">
										{/* Left Button Group */}
										<div className="flex flex-col gap-2">
										<button 
  className={` ${homeDataState.loadingStory1 ? 'button button--primary !bg-gray-400 !cursor-not-allowed' : 'button button--primary'} `}
  disabled={homeDataState.loadingStory1} 
  onClick={(e) => handleCountTokens(e)} 
  id="generateVideo"
>
  Generate all chapters
</button>

										</div>

										{/* Right Button Group */}
										<div className="flex flex-col gap-2">
											<button className="button button--primary" onClick={(e) => handleOpenVideo(e)} id="viewTour">
												View tour data
											</button>

										</div>
									</div>
								</div>

							</div>

						</div>

					</div>
				</div>



			</div>

		</div >

	);
}

export default StoryVideoGeneration;